/** biome-ignore-all lint/style/noNonNullAssertion: need to fix */

import { EXPECTED_CHAIN_ID } from "@/configs/expected-chain";

type T_NET_MODE = "MAIN" | "FORK" | "TEST";
export const NET_MODE: T_NET_MODE = process.env
  .NEXT_PUBLIC_CONTRACT_NET! as T_NET_MODE;

export const CHAIN_ID = EXPECTED_CHAIN_ID;

const isMainOrFork = NET_MODE === "MAIN" || NET_MODE === "FORK";

export const ContractAddress = {
  POLYGON_SCAN: isMainOrFork
    ? "https://polygonscan.com/tx/"
    : "https://amoy.polygonscan.com/tx/",
  POLYGON_ADDRESS_SCAN: isMainOrFork
    ? "https://polygonscan.com/address/"
    : "https://amoy.polygonscan.com/address/",

  MINER: process.env.NEXT_PUBLIC_NFT_MINER!.toLowerCase() as `0x${string}`,
  MINER_MARKET:
    process.env.NEXT_PUBLIC_NFT_MINER_MARKET!.toLowerCase() as `0x${string}`,

  DAO_SAFE_VAULT: (isMainOrFork
    ? process.env.NEXT_PUBLIC_DAO_SAFE_VAULT!
    : process.env.NEXT_PUBLIC_DAO_SAFE_VAULT!
  ).toLowerCase() as `0x${string}`,

  STAKE: (isMainOrFork
    ? process.env.NEXT_PUBLIC_STAKE_META!
    : process.env.NEXT_PUBLIC_STAKE_META_TEST!
  ).toLowerCase() as `0x${string}`,
  CALCULATOR: (isMainOrFork
    ? process.env.NEXT_PUBLIC_CALCULATOR!
    : process.env.NEXT_PUBLIC_CALCULATOR_TEST!
  ).toLowerCase() as `0x${string}`,

  USDT: (isMainOrFork
    ? process.env.NEXT_PUBLIC_USDT!
    : process.env.NEXT_PUBLIC_USDT_TEST!
  ).toLowerCase() as `0x${string}`,

  UVM: (isMainOrFork
    ? process.env.NEXT_PUBLIC_UVM!
    : process.env.NEXT_PUBLIC_UVM_TEST!
  ).toLowerCase() as `0x${string}`,

  DNM: (isMainOrFork
    ? process.env.NEXT_PUBLIC_DNM!
    : process.env.NEXT_PUBLIC_DNM_TEST!
  ).toLowerCase() as `0x${string}`,

  LANDS: (isMainOrFork
    ? process.env.NEXT_PUBLIC_NFT_LAND!
    : process.env.NEXT_PUBLIC_NFT_LAND_TEST!
  ).toLowerCase() as `0x${string}`,

  GATEWAY: (isMainOrFork
    ? process.env.NEXT_PUBLIC_GATEWAY!
    : process.env.NEXT_PUBLIC_GATEWAY_TEST!
  ).toLowerCase() as `0x${string}`,

  /**
   * Gateway V2 — deployed but not yet the app's gateway.
   *
   * `GATEWAY` above stays V1 (everything the site reads still lives there);
   * this address exists only so the DAO proposal form can target V2. Unlike
   * every sibling it tolerates a missing env instead of asserting non-null,
   * because addresses.ts is imported by nearly every page — a `!` here would
   * turn an unset var into a module-load TypeError that blanks the whole app
   * for any dev whose .env.local predates this change. Empty string instead,
   * and the DAO form drops the option (see CONTRACT_OPTIONS).
   */
  GATEWAY_V2: (process.env.NEXT_PUBLIC_GATEWAY_V2 ?? "").toLowerCase() as
    | `0x${string}`
    | "",

  /**
   * Gateway V3 — the transparent proxy, NOT the implementation. This is the
   * stable, user-facing address; the implementation behind it is replaceable
   * through GATEWAY_UPGRADE_CONTROLLER.
   *
   * Same missing-env tolerance as GATEWAY_V2 above, for the same reason.
   */
  GATEWAY_V3: (process.env.NEXT_PUBLIC_GATEWAY_V3 ?? "").toLowerCase() as
    | `0x${string}`
    | "",

  /**
   * GatewayUpgradeController — the two-party governance root for the Gateway V3
   * proxy. Not a business contract: the DAO's only interaction with it is
   * confirming a binding or upgrade proposal the developer has already made.
   *
   * Same missing-env tolerance as GATEWAY_V2 above, for the same reason.
   */
  GATEWAY_UPGRADE_CONTROLLER: (
    process.env.NEXT_PUBLIC_UPGRADE_CONTROLLER ?? ""
  ).toLowerCase() as `0x${string}` | "",

  LAZY_MINT: (isMainOrFork
    ? process.env.NEXT_PUBLIC_LAZY_MINT!
    : process.env.NEXT_PUBLIC_LAZY_MINT_TEST!
  ).toLowerCase() as `0x${string}`,

  MARKET: (isMainOrFork
    ? process.env.NEXT_PUBLIC_MARKET!
    : process.env.NEXT_PUBLIC_MARKET_TEST!
  ).toLowerCase() as `0x${string}`,

  LAND_MARKET: (isMainOrFork
    ? process.env.NEXT_PUBLIC_NFT_LAND_MARKET!
    : process.env.NEXT_PUBLIC_NFT_LAND_MARKET_TEST!
  ).toLowerCase() as `0x${string}`,

  WRAPPER: (isMainOrFork
    ? process.env.NEXT_PUBLIC_WRAPPER!
    : process.env.NEXT_PUBLIC_WRAPPER_TEST!
  ).toLowerCase() as `0x${string}`,

  UVM_BSC: (isMainOrFork
    ? process.env.NEXT_PUBLIC_UVM_BSC!
    : process.env.NEXT_PUBLIC_UVM_BSC_TEST!
  ).toLowerCase() as `0x${string}`,

  DNM_BSC: (isMainOrFork
    ? process.env.NEXT_PUBLIC_DNM_BSC!
    : process.env.NEXT_PUBLIC_DNM_BSC_TEST!
  ).toLowerCase() as `0x${string}`,

  BRIDGE_BSC:
    process.env.NEXT_PUBLIC_BRIDGE_BSC!.toLowerCase() as `0x${string}`,

  LAND_BSC: process.env.NEXT_PUBLIC_NFTLAND_BSC!.toLowerCase() as `0x${string}`,

  ELECTION: (isMainOrFork
    ? process.env.NEXT_PUBLIC_ELECTION!
    : process.env.NEXT_PUBLIC_ELECTION_TEST!
  ).toLowerCase() as `0x${string}`,

  DAO: (isMainOrFork
    ? process.env.NEXT_PUBLIC_DAO!
    : process.env.NEXT_PUBLIC_DAO_TEST!
  ).toLowerCase() as `0x${string}`,

  MARKET_NFT: (isMainOrFork
    ? process.env.NEXT_PUBLIC_MARKET_NFT!
    : process.env.NEXT_PUBLIC_MARKET_NFT_TEST!
  ).toLowerCase() as `0x${string}`,

  NFT: (isMainOrFork
    ? process.env.NEXT_PUBLIC_NFT!
    : process.env.NEXT_PUBLIC_NFT_TEST!
  ).toLowerCase() as `0x${string}`,
};

export default ContractAddress;
